import yahoo from "assets/images/yahoofin.png";
import reuters from "assets/images/reuters.png";
import cbs from "assets/images/cbs.png";
import daily from "assets/images/daily.png";
import star from "assets/images/startrib.png";
import enter from "assets/images/entre.png";
import harvard from "assets/images/harvard.png";
import towards from "assets/images/towards.png";
import lulu from "assets/images/lulu.png";

const featuredImages = [
  {
    img: yahoo,
    alt: "yahoo",
  },
  {
    img: reuters,
    alt: "reuters",
  },
  {
    img: cbs,
    alt: "cbs",
  },
  {
    img: daily,
    alt: "daily",
  },
  {
    img: star,
    alt: "star",
  },
  {
    img: enter,
    alt: "enter",
  },
  {
    img: harvard,
    alt: "harvard",
  },
  {
    img: towards,
    alt: "towards",
  },
  {
    img: lulu,
    alt: "lulu",
  },
];

export default featuredImages;
